import axios from "axios";
import { timeoutStandart, urlApi, getApiUrl } from ".";
import { SecureStorage } from "@helpers/storage";

const instance = axios.create({
  baseURL: getApiUrl(""),
  timeout: timeoutStandart, // Tempo limite para requisições em milissegundos
  headers: {
    "Content-Type": "application/json",
    // Adicione outros cabeçalhos conforme necessário
  },
});

// Adicione este código à sua configuração global do Axios
instance.interceptors.request.use(
  async (config) => {
    // Faça algo antes de enviar a requisição
    const token = await SecureStorage.getItemAsync("TokenUser");
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    // Faça algo com erros de requisição
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // Faça algo com a resposta
    return response;
  },
  (error) => {
    // Faça algo com erros de resposta
    return Promise.reject(error);
  }
);

export default instance;
